import * as actionTypes from './actionTypes';
import * as coSellOpportunityService from './service'
import {applyFilter} from "../../utils/general";

const log = require("loglevel").getLogger("CoSellOpportunityActions");
log.setLevel("error");

export const loadCoSellOpportunities = (accountName, selectedFilters, forceReload) => {
	return async (dispatch) => {
		log.debug("CoSellOpportunityActions -> loadCoSellOpportunities -> Enter");

		const result = await coSellOpportunityService.loadCoSellOpportunities(accountName, selectedFilters, forceReload);

		const records = result?.data || [];
		const total = result?.metadata?.total || records.length;

		let filteredCoSellOpportunities = records;

		selectedFilters?.forEach(filter => {
			filteredCoSellOpportunities = applyFilter(filteredCoSellOpportunities, filter);
		});

		await dispatch({
			type: actionTypes.CO_SELL_OPPORTUNITIES_LOADED,
			data: filteredCoSellOpportunities,
			total
		});
	}
}; 